/*
Inputtypes sind v.a. für Textfelder gedacht.
Die u.a. Funktion(en) einfach über das handleChange-Event einbinden ..
-> die eingebundene Funktion sorgt dann dafür, dass ausschließlich die definierten
 Zeichen akzeptiert werden.
*/
export const numeric = (text) => {
  return text.replace(/\D/g,"");
}
